import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadPartCompleted.meta';

export type UseTrackUploadPartCompletedParams = UploadAnalyticsCommonParams & {
  part_number: number;
  part_size_bytes?: number;
  part_upload_duration_ms?: number;
  retry_count: number;
  max_retry_count?: number;
  upload_url_type: 'primary' | 'fallback';
};

export const useTrackUploadPartCompleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadPartCompleted = useCallback(
    (params: UseTrackUploadPartCompletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadPartCompleted };
};
